import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faShieldHalved,
    faChartLine,
    faBan,
    faTrash,
    faList,
    faBug,
} from '@fortawesome/free-solid-svg-icons';
import SecurityDashboard from './SecurityDashboard';
import BlockedIPsList from './BlockedIPsList';
import BlockIPForm from './BlockIPForm';
import SpamCleanup from './SpamCleanup';
import SecurityStats from './SecurityStats';
import SecurityDiagnostics from './SecurityDiagnostics';

const SecurityManagement = () => {
    const [activeSection, setActiveSection] = useState('dashboard');

    const sections = [
        { id: 'dashboard', label: 'Dashboard', icon: faChartLine },
        { id: 'blocked-ips', label: 'IPs Bloqueadas', icon: faBan },
        { id: 'block-ip', label: 'Bloquear IP', icon: faShieldHalved },
        { id: 'spam-cleanup', label: 'Limpieza Spam', icon: faTrash },
        { id: 'stats', label: 'Estadísticas', icon: faList },
        { id: 'diagnostics', label: 'Diagnóstico', icon: faBug },
    ];

    return (
        <div className="space-y-6">
            {/* Header */}
            <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-200">
                <div className="flex items-center gap-3 mb-2">
                    <FontAwesomeIcon icon={faShieldHalved} className="text-red-600 text-2xl" />
                    <h2 className="text-2xl font-bold text-gray-900">Gestión de Seguridad</h2>
                </div>
                <p className="text-gray-600">
                    Sistema IDS/IPS básico para proteger la plataforma contra ataques y spam.
                </p>
            </div>

            {/* Navigation Tabs */}
            <div className="bg-white rounded-lg shadow-sm border border-gray-200">
                <div className="border-b border-gray-200">
                    <nav className="flex space-x-1 px-4 overflow-x-auto" aria-label="Tabs">
                        {sections.map((section) => (
                            <button
                                key={section.id}
                                onClick={() => setActiveSection(section.id)}
                                className={`
                  flex items-center gap-2 py-4 px-4 font-medium text-sm whitespace-nowrap border-b-2 transition-colors
                  ${activeSection === section.id
                                        ? 'border-red-600 text-red-600'
                                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                                    }
                `}
                            >
                                <FontAwesomeIcon icon={section.icon} />
                                {section.label}
                            </button>
                        ))}
                    </nav>
                </div>

                {/* Content */}
                <div className="p-6">
                    {activeSection === 'dashboard' && <SecurityDashboard />}
                    {activeSection === 'blocked-ips' && <BlockedIPsList />}
                    {activeSection === 'block-ip' && <BlockIPForm />}
                    {activeSection === 'spam-cleanup' && <SpamCleanup />}
                    {activeSection === 'stats' && <SecurityStats />}
                    {activeSection === 'diagnostics' && <SecurityDiagnostics />}
                </div>
            </div>
        </div>
    );
};

export default SecurityManagement;

